import { Component,Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Menu } from '../../../../../asistente-en-linea/models/Menu';
import { MenuService } from '../../menu.service';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-import-destval-dialog',
  templateUrl: './import-destval-dialog.component.html',
  styleUrls: ['./import-destval-dialog.component.scss']
})
export class ImportDestinatarioValidacionDialogComponent implements OnInit {
  errores: string[];
  erroresDestinatarios: string[];
  erroresValidaciones: string[];
  exitoso: boolean;                    
  formData: any = null;
  respuestaImportacion:any=null;
  selectedFile: any = null;
  habilitarBotonImportar: boolean;
  mostrarMensajeEjecutando: boolean;
  ejecutando : boolean;
  finalizado : boolean;
  mensaje: string;
  error: boolean;
  constructor(private menuService: MenuService,private authService: AuthService,
    public dialogRef: MatDialogRef<ImportDestinatarioValidacionDialogComponent>) { 
    this.habilitarBotonImportar = false;  
    this.mostrarMensajeEjecutando = false;
    this.ejecutando = false;    
    this.finalizado = false;
    this.error = false;                                                 
  }

  ngOnInit() {
  }
  cancelarAceptar(): void {
    this.dialogRef.close();                         
  }

  onFileSelected(event: any): void {
    this.error = false;
    this.errores = [];
    this.habilitarBotonImportar = false;
  
    const file = event.target.files?.[0];
  
    if (!file) {
      return;
    }
  
    const extension = file.name.split('.').pop()?.toLowerCase();
  
    if (extension === 'xls' || extension === 'xlsx') {
      this.selectedFile = file;
  
      this.formData = new FormData();
      this.formData.append('file', file); 
      this.formData.append('fileName', file.name);
  
      this.habilitarBotonImportar = true;
  
    } else {
      this.error = true;
      this.mensaje = "Debe seleccionar un archivo en formato XLS/XLSX";
      this.errores.push(this.mensaje);
    }
  }

  async importar()  {
    this.respuestaImportacion = null;
    this.error = false;   
    this.ejecutando = true;
    this.finalizado = false;
    this.exitoso = false;
    this.habilitarBotonImportar = false;   
    this.mostrarMensajeEjecutando = true;
    this.errores = [];
    this.erroresDestinatarios = [];
    this.erroresValidaciones = [];
    this.menuService.importarDestinatariosAsistentes(this.formData,this.authService.getUser().username).subscribe((data: any) => {
      if (data && (data.statusCode == 200 ||data.statusCode ==0)) {
        this.respuestaImportacion=data;
        this.selectedFile = null;
        this.mostrarMensajeEjecutando = false;
        this.finalizado = true;
        this.exitoso = data.exitoso;
        this.errores = data.errores;
        this.erroresDestinatarios = data.erroresDestinatarios;
        this.erroresValidaciones = data.erroresValidaciones;
        if(this.errores.length > 0 || this.erroresDestinatarios.length > 0 || this.erroresValidaciones.length > 0) {
          this.exitoso = false;
          this.error = true;  
        }
      } else {
        //this.errores.push("Error al realizar la importación de destinatarios o validaciones");
        //alert(data.statusMessage);
        this.exitoso = false;
        this.ejecutando = false;
        this.error = true;   
      }
    },
    error=>{
      //alert(error);
      this.mensaje = error;
      this.ejecutando = false;
      this.error = true;   
    })
  }
}